import { LinkProps } from "react-router-dom";

import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";

export const LinkWrapper = (props: Partial<LinkProps>) => {
  const { children, to, ...rest } = props;
  if (to) {
    return (
      <LocalizedLink to={to} {...rest}>
        {children}
      </LocalizedLink>
    );
  }
  return <>{children}</>;
};
